import React, { useState, useEffect } from 'react'
import { Tabs, Tab } from 'react-bootstrap'
import styled from 'styled-components'
import { useSelector, useDispatch } from 'react-redux'
import { SIDEPANEL_WIDTH } from '../../utils'
import { updateUi } from '../../dux/ui/actions'
import classnames from 'classnames'
import { useCloseSidePanelPopOver } from './hooks'
import metricDefinitions from '../../metricDefinitions'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

export default function SidePanel(props) {
  const [ activeKey, setActiveKey ] = useState('program')
  const [filter, setFilter] = useState('')
  const { organization_name, permissions } = useSelector(state => state.static)

  useEffect(()=>{
    if (window.location.hash){
      setActiveKey(window.location.hash.substr(1))
    }
  },[])

  return (
    <Variant {...props}>
      <div className="" style={{height: 'calc(100%)', overflowY: 'scroll' }}>
        <div className="d-flex flex-column h-100 justify-content-between">
          <div>
            <div className="pl-3 pr-3 pt-2">
              <input
                  className="form-control form-control-sm w-100 mt-3 mb-3"
                  placeholder="Type name..."
                  value={filter}
                  onChange={(e)=>setFilter(e.target.value)}/>
              {props.children}
            </div>

            <hr className="mt-4 mb-0"/>

            <div className="pt-3" style={{overflowY: "scroll", height: '100%'}}>
              {
                Object.entries(metricDefinitions(organization_name, permissions))
                    .filter(el => !el[0].startsWith("post"))
                    .filter(el => el[1].visible)
                    .map(el => {
                      const smallName = el[0]
                      const obj = el[1]
                      return (
                          smallName.includes(filter.toLowerCase()) &&
                          <LinkItem to={obj.link}
                                    name={obj.name}
                                    smallName={smallName} />
                      )
                    })
              }
            </div>
          </div>
        </div>
      </div>
    </Variant>
  )
}

function LinkItem(props){
  const { to, name, smallName } = props
  const isSelected = useSelector(state => state.selected.smallName === smallName)
  const handleCloseSidePanelPopOver = useCloseSidePanelPopOver()
  const dispatch = useDispatch()

  function handleClick(){
    dispatch({type: "UPDATE_SELECTED", payload: {link: props.to, name: props.name, smallName: props.smallName}})
    handleCloseSidePanelPopOver()
  }

  return(
    <Link to={to}>
      <div
        onClick={handleClick} 
        className={classnames("pl-3 pr-3 pt-2 pb-2 hoverable clickable cursor-pointer text-capitalize d-flex justify-content-between align-items-center", { "bg-primary": isSelected })}
        style={{color: isSelected ? 'white' : 'black'}}>
        {name}
      </div>
    </Link>
  )
}

function Variant({ children, variant }){
  const { visible } = useSelector(state=>state.ui.sidePanelPopOver)
  const handleCloseSidePanelPopOver = useCloseSidePanelPopOver()

  return variant == 'popover' ?
  <PopOver id="side_panel_outcomes" style={{display: visible ? "block" : "none"}}>
    <div className="d-flex justify-content-end p-3 border-bottom">
      <span onClick={handleCloseSidePanelPopOver} className="btn btn-primary">
        <span>Back to Outcomes</span>
      </span>
    </div>
    {children}
  </PopOver> : 
  <div id="side_panel_outcomes" className="h-100 border d-none d-lg-block" transition='false' style={{width: SIDEPANEL_WIDTH }}>{children}</div>
}

const PopOver = styled.div`
  position: fixed;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  padding-top: 55px;
  background-color: white;
  display: inline-block;
  z-index: 1000;
`